import { Card, Col, Row, Image, Button, Upload as UploadAntd, Form, message, Modal, Table, Input } from "antd";
import React, { useEffect, useState, useForm } from "react";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import UploadIcon from "../assets/images/upload-icon.svg";
import ModalDeleteIcon from "../assets/images/delete-icon.svg";
import useRequest from "../hooks/useRequest";
import apiPath from "../constants/apiPath";
import { S3Client } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';
import FormItem from "antd/es/form/FormItem";
import ViewTableIcon from "../assets/images/view-table-icon.svg";
import EditTableIcon from "../assets/images/edit-icon-table.svg";
import DeleteTableIcon from "../assets/images/delete-table-icon.svg";
import { ShowToast, Severty } from "../helper/toast";
import { InboxOutlined, PlusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import Dragger from "antd/lib/upload/Dragger";
const s3Config = {
  region: 'us-east-1',
  credentials: {
    accessKeyId: "AKIAFBC97UM4I3ILWTIKQ",
    secretAccessKey: "vMUNWcZvMesuFfmUwdUYnsaOr1pp38wu8nOon8eb",
  },
  endpoint: "https://s3-noi.aces3.ai/",
  forcePathStyle: true,
  requestChecksumCalculation: "WHEN_REQUIRED",
  responseChecksumValidation: "WHEN_REQUIRED",
};
const s3Client = new S3Client(s3Config);
const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

const VideoFileType = ["video/mp4", "video/mov"];
const FileType = ["image/png", "image/jpg", "image/jpeg"];

function ContactAccess() {
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [file, setFile] = useState([]);
  const [fileEdit, setFileEdit] = useState([]);
  const [imageEdit, setImageEdit] = useState("");
  const [image, setImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [selectedContent, setSelectedContent] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpenList, setDeleteOpenList] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [fileNames, setFileNames] = useState([]);
  const [importFile, setImportFile] = useState([]);
  const [error, setError] = useState();
  const [project, setProject] = useState([]);
  const [location, setLocation] = useState([]);
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 100 }, (_, i) => currentYear - i);
  const [columnHeaders, setColumnHeaders] = useState([]);
  const [isLocationModalVisible, setIsLocationModalVisible] = useState(false);
  const [isProjectModalVisible, setIsProjectModalVisible] = useState(false);
  const [dbHeaders, setDbHeaders] = useState([]);
  const [mismatchColumns, setMismatchColumns] = useState([]);
  const [matchColumns, setMatchColoum] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [bindings, setBindings] = useState({});
  const [bindingsNew, setBindingsNew] = useState({});
  const [uploadedHeaders, setUploadedHeaders] = useState([]);
  const { request } = useRequest();
  const fileType = [
    "text/csv",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
  ];
  const handleImport = (info) => {
    setLoading(true);
    const { file, fileList } = info;
    if (fileList?.length) {
      if (!fileType.includes(file.type) && !file.name.endsWith('.csv')) {
        ShowToast("File format is not correct", Severty.ERROR);

        // setError("File format is not correct");
        setLoading(false); // Stop loading on error
        return false;
      }
      setError();
      const fileData = {
        lastModified: file.lastModified,
        lastModifiedDate: file.lastModifiedDate,
        name: file.name,
        uid: file.uid,
        status: "done",
        originFileObj: file.originFileObj,
        size: file.size,
        type: file.type,
        percent: file.percent,
      };
      setFile([fileData]);
      parseExcel(file.originFileObj);
    } else {
      // ShowToast('Missing Excel File', Severty.error);
      ShowToast("Missing Excel File", Severty.ERROR);
      setLoading(false); // Stop loading if no file is found
    }
  };

  const parseExcel = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const parsedData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        defval: "",
      });
      setImportFile(parsedData.slice(1));
      setModalVisible(true);


      const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, "");
      setFileNames(fileNameWithoutExtension);
      setLoading(false);
    };
    reader.readAsArrayBuffer(file);
  };

  const uploadFileToS3 = async (file, bucketName) => {
    const key = "taxi/profile/" + file.name
    const params = {
      Bucket: bucketName,
      Key: key,
      Body: file,
    };

    const upload = new Upload({
      client: s3Client,
      params: params,
    });

    try {
      const data = await upload.done();
      console.log(data, "line 47");
      return data;
    } catch (err) {
      throw err;
    }
  };
  const FileType = ["image/png", "image/jpg", "image/jpeg", "image/avif", "image/webp", "image/gif"]
  const beforeUpload = (file) => {
    if (FileType.includes(file.type)) {

    } else {
      message.error("File format is not correct")
      return false
    }
    const isLt2M = file.size / 1024 / 1024 < 5;

    if (!isLt2M) {
      message.error(`Image must be smaller than 5 MB!`)
      return false
    }
    return true
  }

  const handleChange = async (event) => {
    const { file } = event;
    setFile([file]);
    try {
      const data = await uploadFileToS3(file, 'invent-co-new');
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: 'done',
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);


      form.setFieldsValue({ image: data.Location });

      console.log(data, "line 83");
    } catch (err) {
      console.error(err);
    }
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const fetchContent = () => {
    setLoading(true);
    request({
      url: "/business/contact/get-list",
      method: "GET",
      onSuccess: (data) => {
        if (data.status) {
          setDataSource(data.data.data)

          // const description = data.data.data[0].description || "";
          // const image = data.data.data[0].image || "";
          // setText(description);
          // setImage(image);
          // form.setFieldsValue({
          //   description: description,
          //   image: image
          // });
          // setFile([{
          //   url: image,
          // }]);
          // handleQuillChange(description)



        } else {
          message.error(data.message || "Failed to fetch content");
        }
        setLoading(false);
      },
      onError: (error) => {
        message.error(error?.message || "An error occurred while fetching content");
        setLoading(false);
      },
    });
  };



  useEffect(() => {
    fetchContent();
  }, []);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      const plainTextDescription = stripHtml(values.description);
      request({
        url: apiPath.createContent,
        method: "POST",
        data: {
          description: plainTextDescription,
          image: values.image || file[0]?.url || ""
        },
        onSuccess: (data) => {
          if (data.status) {
            message.success("Content updated successfully!");
            ShowToast("Content updated successfully!", Severty.SUCCESS);
            fetchContent();
          } else {
            message.error(data.message || "Failed to update content");
          }
        },
        onError: (error) => {
          message.error(error?.message || "An error occurred while updating content");
        },
      });
    });
  };


  const onRemove = (file) => {
    setSelectedFile(file);
    setDeleteOpen(true);
    return false;
  };

  const handleDeleteConfirm = () => {
    setFileList(fileList.filter((item) => item.uid !== selectedFile.uid));
    setDeleteOpen(false);
    setSelectedFile(null);
    message.success("File deleted successfully!");
  };


  const modules = {
    toolbar: [
      [{ size: [] }],
      ["bold", "italic"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: [] }],
      ["link", "image"],
      ["emoji"],
    ],
  };

  const handleQuillChange = (e) => {
    console.log(e)
    setText(e);
    form.setFieldsValue({ description: e });
  };

  const handleEditContent = (record) => {
    if (!record || !record._id) {
      message.error("Invalid question record");
      return;
    }
    setSelectedContent(record);
    form1.setFieldsValue({
      image: record.image,
      description: record.description,
    });
    setFileEdit([{
      url: image,
    }]);
    setImageEdit(record.image);
    setEditOpen(true);
  };

  const showDeleteConfirm = (record) => {
    setSelectedContent(record);
    setDeleteOpenList(true);
  };

  const handleDeleteContent = () => {
    if (!selectedContent?._id) {
      message.error("Content ID is missing");
      return;
    }

    setLoading(true);
    request({
      url: `${apiPath.deleteContent}/${selectedContent._id}`,
      method: "DELETE",
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          message.success(data.message || "Content deleted successfully");
          setDeleteOpenList(false);
          fetchContent();
        } else {
          message.error(data.message || "Failed to delete Content");
        }
      },
      onError: (error) => {
        setLoading(false);
        message.error(
          error?.message || "An error occurred while deleting the Content"
        );
      },
    });
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (title) => (
        <div>
          <p className="description">{title}</p>
        </div>
      ),
    },
    {
      title: "List Name",
      dataIndex: "file_name",
      key: "file_name",
      render: (file_name) => (
        <div>
          <p className="description">{file_name}</p>
        </div>
      ),
    },
    {
      title: "ACTION'S",
      key: "actions",
      width: 150,
      render: (record) => (
        <div className="actions">
          <Button
            className="delete-btn-table"
            icon={<img src={DeleteTableIcon} alt="Delete" />}
            onClick={() => showDeleteConfirm(record)}
          />
        </div>
      ),
    },
  ];


  const onSubmit = (values) => {
    if (error) return;

    if (fileNames.length) {
      setLoading(true);
      const payload = {
        import_file: importFile,
        file_name: fileNames,
        totalContact: importFile.length,
        title: values.title
      };

      // Send request
      request({
        url: "/business/contact/add-contact-access",
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            form.resetFields()
            setIsModalOpen(false)
            ShowToast(data.message, Severty.SUCCESS);
            fetchContent();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          ShowToast(
            error.response.data.errors[0]?.message || "An error occurred",
            Severty.ERROR
          );
          setLoading(false);
        },
      });
    } else {
      setError("Please Select an Excel File.");
    }
  };



  const downloadDummyExcel = () => {
    const dummyData = [
      ["الاسم الأول", "الاسم الأخير", "رقم الجوال", "الايميل", "مخصص 1", "مخصص 2", "مخصص 3", "مخصص 4"],
      ["أحمد", "محمد", "1234567890", "john@example.com", "", "", "", ""],
      ["علي", "سالم", "0987654321", "ali@example.com", "", "", "", ""],
    ];

    // Create a new workbook and a new worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(dummyData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dummy Data");

    // Generate buffer
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

    // Create a Blob from the buffer
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);

    // Create a link element and trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "dummy_data.xlsx"); // Specify the file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  return (
    <>
      <div className="page-top-space home-card layout-content">
        <div className="mb-24">
          <Row gutter={[24, 0]}>
            <Col xs={24} sm={24} md={24}>


              <Card bordered={false} className="card-main">

                <div className="upload-contant-card">
                  <div className="upload-card-header">
                    <div className="dashbord-headding-cont">
                      <h6>Contact List</h6>
                      <Button type="primary" className="fill-btn" onClick={showModal}>
                        <PlusOutlined /> Add Contact List
                      </Button>
                    </div>

                    {/* <p>Lorem ipsum dolor sit amet consectetur. Duis cursus amet massa</p> */}
                    <div className="table-responsive">
                      <Table
                        dataSource={dataSource}
                        columns={columns}
                        loading={loading}
                        rowKey="id"
                        pagination={pagination}
                        onChange={handleTableChange}
                      />
                    </div>

                  </div>
                </div>

              </Card>

            </Col>
          </Row>
        </div>
      </div>
      <Modal
        title="Add Contact List"
        className="tab_modal"
        width={600}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Card bordered={false} className="card-main">

          <Form id="create" form={form} onFinish={onSubmit} layout="vertical">
            <Row gutter={[24, 0]}>
              <Col span={24}>
                <Form.Item
                  label={
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span style={{ fontSize: "18px", fontWeight: "500" }}>Select File</span>
                      <a onClick={downloadDummyExcel} style={{ fontSize: "14px", fontWeight: "700", padding: "10px" }}>
                        ( Download Dummy Excel )
                      </a>
                    </div>
                  }
                  name="import_file"
                  rules={[{ required: true, message: "Please upload a file" }]}
                >
                  <Dragger
                    fileList={file}
                    onRemove={() => setFile([])}
                    maxCount={1}
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onChange={handleImport}
                    customRequest={() => null}
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or Drag File to This Area to Upload</p>
                    <p className="ant-upload-hint">Please select an Excel file.</p>
                  </Dragger>
                </Form.Item>
              </Col>

              <Col span={24} md={24}>
                <Form.Item
                  label="Title"
                  name="title"
                  rules={[{ required: true, message: "Please enter a title" }]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={24} md={24}>
                <Form.Item className="submit-new-main-buttonh">
                  <Button
                    type="primary"
                    className="fill-btn"
                    htmlType="submit"
                    style={{ alignItems: "left" }}
                    disabled={loading}
                  >
                    Submit
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>



        </Card>
      </Modal>

      {/* Edit Question Modal */}
      <Modal
        title=""
        className="tab_modal"
        width={900}
        open={editOpen}
        onCancel={() => {
          setEditOpen(false);
          form1.resetFields();
        }}
        footer={[false]}
      >
        <Form id="create" form={form1} onFinish={onSubmit} layout="vertical">
          <Row gutter={[24, 0]}>
            <Col span={24}>
              <Form.Item
                label="Select File"
                name="import_file"
                rules={[{ required: true, message: "" }]}
              >
                <Dragger
                  fileList={file}
                  onRemove={() => setFile([])}
                  maxCount={1}
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  onChange={handleImport}
                  customRequest={() => null}
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click or Drag File to This Area to Upload
                  </p>
                  <p className="ant-upload-hint">
                    Please Select an Excel File.
                  </p>
                </Dragger>
              </Form.Item>
            </Col>

            <Col span={24} md={12}>
              <Form.Item label="Title" name="title">
                <Input />
              </Form.Item>
            </Col>
            <Col span={24} md={24}>
              <Form.Item className="submit-new-main-buttonh">
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ alignItems: "left" }}
                  disabled={loading}
                >
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      {/* Delete Question Modal */}
      <Modal
        title=""
        className="tab_modal"
        open={deleteOpenList}
        onCancel={() => setDeleteOpenList(false)}
        footer={[false]}
      >
        <div className="modal-inner-body">
          <img className="check-tital-icon" src={ModalDeleteIcon} />
          <h6>Are you sure you want to delete?</h6>

          <Button
            className="modal-fill-btn"
            type="primary"
            onClick={handleDeleteContent}
          >
            Continue
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default ContactAccess;
